








import { Component, Prop, Vue } from "vue-property-decorator";
import ShopMenuItemServiceBase from "./ShopMenuItemServiceBase.vue";
import { Service, ServicePackage } from "@/api/types";

@Component({
  components: {
    ShopMenuItemServiceBase
  }
})
export default class ShopMenuItemServiceSinglePackage extends Vue {
  @Prop() private service!: Service;
  @Prop({ default: false }) private selected!: boolean;

  get servicePackage(): ServicePackage {
    return Object.values(this.service.packages)[0];
  }

  get durationText() {
    const { hideDurations,duration } = this.service;
    if (hideDurations) return null;
    return `${duration} min`;
  }

  get priceText() {
    const { price } = this.servicePackage;
    return `€${price}`;
  }
}
